var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "debug-card pa-2" },
            [
              _c("h2", [_vm._v("Zastupca data")]),
              _c(
                "v-card-actions",
                _vm._l(_vm.varianty, function(v, i) {
                  return _c(
                    "v-btn",
                    {
                      key: i,
                      staticClass: "btn-secondary",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.variantDebugIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(i))]
                  )
                }),
                1
              ),
              _c("v-card-text", [
                _vm.varianty
                  ? _c(
                      "table",
                      _vm._l(_vm.getVariantyDebugEntries(), function(ref) {
                        var key = ref[0]
                        var value = ref[1]
                        return _c("tr", { key: key }, [
                          _c("th", [_vm._v(_vm._s(key) + ":")]),
                          _c("td", { staticClass: "pl-2" }, [
                            _vm._v(_vm._s(value))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "900"
          },
          model: {
            value: _vm.showScoring,
            callback: function($$v) {
              _vm.showScoring = $$v
            },
            expression: "showScoring"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [_vm._v(" Scoring ")]
              ),
              _c(
                "v-card-text",
                [
                  _c("scoring-parameters", {
                    ref: "scoring",
                    attrs: {
                      scoringData: _vm.scoringData,
                      variant: _vm.scoringVariant
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.saveScoring()
                        }
                      }
                    },
                    [_vm._v(" Uložiť ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "card" },
        [
          !_vm.isMobile
            ? _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c("div", { staticClass: "mr-auto" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center",
                        staticStyle: { "max-width": "740px" }
                      },
                      [
                        _c("h2", [_vm._v(_vm._s(_vm.predmet.nazov_predmetu))]),
                        _vm.showSelectedStateIcon
                          ? _c(
                              "v-icon",
                              { staticClass: "sumar-predmet-check-icon ml-2" },
                              [_vm._v(" mdi-check ")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("p", { staticClass: "f16 c-grayscale-100 mt-1" }, [
                      _vm._v(" " + _vm._s(_vm.predmet.typ_predmetu) + " ")
                    ])
                  ]),
                  _vm.predmet.stav != null
                    ? _c(
                        "div",
                        [
                          _c(
                            "status",
                            {
                              attrs: {
                                custom: "",
                                color: _vm.predmet.farba,
                                large: ""
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.predmet.stav) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "f18 ml-3" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "f12 gs100 d-block mb-n4px",
                          staticStyle: {
                            "white-space": "nowrap",
                            "text-align": "end"
                          }
                        },
                        [_vm._v("Kúpna cena")]
                      ),
                      _c(
                        "b",
                        {
                          staticClass: "d-block text-right",
                          staticStyle: { "white-space": "nowrap" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.predmet.oc_s_dph
                                ? _vm.predmet.oc_s_dph.toEurString()
                                : ""
                            )
                          )
                        ]
                      ),
                      _vm.predmet.cena_car_catalog && _vm.jeDealer
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "f16 gs100 d-block mb-n8px",
                                staticStyle: { "white-space": "nowrap" }
                              },
                              [_vm._v("Ocenenie: ")]
                            ),
                            _c("b", { staticClass: "text-right d-block" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.predmet.cena_car_catalog
                                    ? _vm.predmet.cena_car_catalog.toEurString()
                                    : ""
                                )
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.getMenuItem("duplikovat").is_visible
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            "close-delay": 0,
                            "open-delay": 200
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "btn-secondary btn-icon ml-10",
                                          attrs: {
                                            disabled:
                                              _vm.getMenuItem("duplikovat")
                                                .is_enabled === 0
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.duplikujPredmet(
                                                _vm.predmet.cislo_predmetu
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass:
                                              "f20 material-icons-outlined"
                                          },
                                          [_vm._v("$copy")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            895865594
                          )
                        },
                        [_c("span", [_vm._v("Duplikovať")])]
                      )
                    : _vm._e(),
                  _vm.getMenuItem("edit").is_visible
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            "close-delay": 0,
                            "open-delay": 200
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "btn-secondary btn-icon ml-3",
                                          attrs: {
                                            disabled:
                                              _vm.getMenuItem("edit")
                                                .is_enabled === 0 ||
                                              _vm.pripad == null ||
                                              _vm.pripad.newId == null
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.editovaniePredmetu()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { staticClass: "f20" }, [
                                          _vm._v("$edit")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            203593467
                          )
                        },
                        [_c("span", [_vm._v("Editovať")])]
                      )
                    : _vm._e(),
                  _vm.getMenuItem("zmazat").is_visible
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            "close-delay": 0,
                            "open-delay": 200
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "btn-secondary btn-icon ml-3",
                                          attrs: {
                                            disabled:
                                              _vm.getMenuItem("zmazat")
                                                .is_enabled === 0
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openDeleteDialog(
                                                _vm.predmet.cislo_predmetu
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { staticClass: "f20" }, [
                                          _vm._v("$trash")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            306570966
                          )
                        },
                        [_c("span", [_vm._v("Zmazať")])]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-icon ml-3",
                      attrs: { icon: "" },
                      on: {
                        click: function() {
                          return _vm.$emit("setShowPredmet", !_vm.show)
                        }
                      }
                    },
                    [
                      _c("v-icon", { class: { "rotate-180": _vm.show } }, [
                        _vm._v("mdi-chevron-down")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "div",
                  [
                    _vm.getMenuItem("duplikovat").is_visible
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "btn-secondary btn-icon",
                            attrs: {
                              disabled:
                                _vm.getMenuItem("duplikovat").is_enabled === 0
                            },
                            on: {
                              click: function($event) {
                                return _vm.duplikujPredmet(
                                  _vm.predmet.cislo_predmetu
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "f20 material-icons-outlined" },
                              [_vm._v("$copy")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.getMenuItem("edit").is_visible
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "btn-secondary btn-icon ml-2",
                            attrs: {
                              disabled:
                                _vm.getMenuItem("edit").is_enabled === 0 ||
                                _vm.pripad == null ||
                                _vm.pripad.newId == null,
                              to:
                                "/obchodny-pripad/" +
                                _vm.pripad.newId +
                                "?cislo_predmetu=" +
                                _vm.predmet.cislo_predmetu +
                                "&step=2"
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "f20" }, [
                              _vm._v("$edit")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.getMenuItem("zmazat").is_visible
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "btn-secondary btn-icon ml-2",
                            attrs: {
                              disabled:
                                _vm.getMenuItem("zmazat").is_enabled === 0
                            },
                            on: {
                              click: function($event) {
                                return _vm.openDeleteDialog(
                                  _vm.predmet.cislo_predmetu
                                )
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "f20" }, [
                              _vm._v("$trash")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-icon right",
                        attrs: { icon: "" },
                        on: {
                          click: function() {
                            return _vm.$emit("setShowPredmet", !_vm.show)
                          }
                        }
                      },
                      [
                        _c("v-icon", { class: { "rotate-180": _vm.show } }, [
                          _vm._v("mdi-chevron-down")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "mt-6 mb-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center mb-2",
                      staticStyle: { "max-width": "740px" }
                    },
                    [
                      _c("h2", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.predmet.nazov_predmetu))
                      ]),
                      _vm.showSelectedStateIcon
                        ? _c(
                            "v-icon",
                            { staticClass: "sumar-predmet-check-icon ml-2" },
                            [_vm._v(" mdi-check ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("span", { staticClass: "f16 c-grayscale-100" }, [
                    _vm._v(" " + _vm._s(_vm.predmet.typ_predmetu) + " ")
                  ])
                ]),
                _vm.predmet.stav != null
                  ? _c(
                      "div",
                      [
                        _c(
                          "status",
                          {
                            attrs: {
                              custom: "",
                              color: _vm.predmet.farba,
                              large: ""
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.predmet.stav) + " ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "f18" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "f12 gs100 d-block mb-n4px",
                        staticStyle: { "white-space": "nowrap" }
                      },
                      [_vm._v("Kúpna cena")]
                    ),
                    _c(
                      "b",
                      {
                        staticClass: "d-block",
                        staticStyle: { "white-space": "nowrap" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.predmet.oc_s_dph
                              ? _vm.predmet.oc_s_dph.toEurString()
                              : ""
                          )
                        )
                      ]
                    ),
                    _vm.predmet.cena_car_catalog && _vm.jeDealer
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "f16 gs100 d-block mb-n8px",
                              staticStyle: { "white-space": "nowrap" }
                            },
                            [_vm._v("Ocenenie: ")]
                          ),
                          _c("b", { staticClass: "d-block" }, [
                            _vm._v(
                              _vm._s(
                                _vm.predmet.cena_car_catalog
                                  ? _vm.predmet.cena_car_catalog.toEurString()
                                  : ""
                              )
                            )
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
          _c("v-expand-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show,
                    expression: "show"
                  }
                ]
              },
              [
                _vm.stavPonuky
                  ? _c("div", { staticClass: "mb-16px mt-16px w60" }, [
                      _c("span", {
                        staticClass: "gs100 f18",
                        domProps: { innerHTML: _vm._s(_vm.stavPonuky) }
                      })
                    ])
                  : _vm._e(),
                _vm.showEmailSpoludlznika
                  ? _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "mb-16px",
                        nativeOn: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticStyle: { gap: "30px" },
                            attrs: { "no-gutters": "" }
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "pa-0", attrs: { cols: "4" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "dynamic-input-control required",
                                  attrs: {
                                    label: "E-mail spolužiadateľa",
                                    rules: [_vm.required, _vm.email],
                                    outlined: "",
                                    required: ""
                                  },
                                  nativeOn: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.odoslatRegistraciuSpoludlznikovy(
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.emailSpoludlznik,
                                    callback: function($$v) {
                                      _vm.emailSpoludlznik = $$v
                                    },
                                    expression: "emailSpoludlznik"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { staticClass: "pa-0", attrs: { cols: "auto" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-secondary f16 mt-1",
                                    staticStyle: {
                                      height: "auto !important",
                                      padding: "14.5px 28px"
                                    },
                                    on: {
                                      click:
                                        _vm.odoslatRegistraciuSpoludlznikovy
                                    }
                                  },
                                  [_vm._v("Odoslať e-mail")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "mb-16px" },
                  _vm._l(_vm.zmluvy, function(zmluva, i) {
                    return _c(
                      "v-card",
                      {
                        key: i,
                        staticClass: "card-item pa-20px mb-24px",
                        attrs: { elevation: "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-row" },
                          [
                            _c("text-group", {
                              staticClass: "flex-grow-1 mr-20px",
                              attrs: {
                                utext: "Číslo zmluvy",
                                btext: zmluva.cislo_lz,
                                smallHeader: ""
                              }
                            }),
                            zmluva.poznamka != null || zmluva.poznamka_2 != null
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "d-flex pt-6px ml-auto pr-3",
                                    staticStyle: { "z-index": "2" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "bold sumar-item-arrow-color",
                                        staticStyle: {
                                          "font-size": "15px",
                                          "white-space": "nowrap"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openSuhlasDialog(zmluva)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" Súhlas s podmienkami "),
                                        _c("v-icon", [
                                          _vm._v("mdi-chevron-right")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("text-group", {
                              staticClass: "mr-20px",
                              attrs: {
                                utext: "Akontácia",
                                btext: zmluva.akont_perc.toPercentString(2),
                                smallHeader: ""
                              }
                            }),
                            _c("text-group", {
                              staticClass: "mr-20px",
                              attrs: {
                                utext: "Dĺžka splácania",
                                btext: zmluva.tenor,
                                smallHeader: ""
                              }
                            }),
                            _c("text-group", {
                              staticClass: "mr-20px",
                              attrs: {
                                utext: "Splátka",
                                btext: zmluva.splatka.toEurString(),
                                smallHeader: ""
                              }
                            }),
                            _c("text-group", {
                              staticClass: "mr-20px",
                              attrs: {
                                utext: "Perióda",
                                btext: zmluva.perioda,
                                smallHeader: ""
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "mr-20px" },
                              [
                                _c(
                                  "status",
                                  {
                                    attrs: {
                                      custom: "",
                                      color: zmluva.farba,
                                      large: ""
                                    }
                                  },
                                  [
                                    _vm._v(" " + _vm._s(zmluva.stav) + " "),
                                    _vm.jeDealer && zmluva.iur
                                      ? [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                top: "",
                                                "close-delay": 0,
                                                "open-delay": 200
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "btn-help poznamka-icon",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.nastavPoznamkuAndIur(
                                                                    zmluva,
                                                                    true
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " mdi-alert-circle "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [_c("span", [_vm._v("Poznámka")])]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-primary radius-4 f14 mr-20px",
                                attrs: { disabled: !zmluva.enabled, small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.openPripravZmluvuDialog(zmluva)
                                  }
                                }
                              },
                              [_vm._v("Priprav zmluvu")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  [
                    _vm.ponuknuteVarianty != [] &&
                    _vm.ponuknuteVarianty.length > 0
                      ? [
                          _c("span", { staticClass: "f18 gs100" }, [
                            _vm._v(
                              "Vami zvolená ponuka nemôže byť schválená. Ponúkame vám nasledujúce možnosti:"
                            )
                          ]),
                          _c(
                            "v-item-group",
                            {
                              staticClass: "py-12px",
                              attrs: { multiple: false }
                            },
                            [
                              _c(
                                "v-row",
                                _vm._l(_vm.ponuknuteVarianty, function(
                                  variant,
                                  i
                                ) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: i,
                                      staticClass: "pa-12px",
                                      attrs: { cols: true ? 12 : 3 }
                                    },
                                    [
                                      _c(
                                        "v-item",
                                        { attrs: { value: variant } },
                                        [
                                          _c("sumar-produkt-variant", {
                                            staticStyle: { cursor: "auto" },
                                            attrs: {
                                              row: true,
                                              value: variant,
                                              pravoNaAdresnuPonuku:
                                                _vm.pravoNaAdresnuPonuku
                                            },
                                            on: {
                                              odoslatClick: function($event) {
                                                return _vm.vyberVariant(variant)
                                              },
                                              reloadPonuknuteVarianty:
                                                _vm.nacitajZmluvy
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _c("span", { staticClass: "f18" }, [
                      _vm._v("Ponuky na schválenie")
                    ]),
                    _c(
                      "v-item-group",
                      {
                        staticClass: "py-12px",
                        attrs: { multiple: false, value: _vm.selectedVariant }
                      },
                      [
                        _c(
                          "v-row",
                          _vm._l(_vm.varianty, function(variant, i) {
                            return _c(
                              "v-col",
                              {
                                key: i,
                                staticClass: "pa-12px",
                                attrs: {
                                  sm: "12",
                                  md: _vm.row_variant ? 12 : 3
                                }
                              },
                              [
                                _c(
                                  "v-item",
                                  { attrs: { value: variant } },
                                  [
                                    _c("sumar-produkt-variant", {
                                      attrs: {
                                        row: _vm.row_variant,
                                        value: variant,
                                        odoslane: false,
                                        pravoNaAdresnuPonuku:
                                          _vm.pravoNaAdresnuPonuku,
                                        jeDealer: _vm.jeDealer,
                                        jePrihlaseny: _vm.jePrihlaseny,
                                        formaPodnikania: _vm.formaPodnikania
                                      },
                                      on: {
                                        nastavPoznamku: function(value) {
                                          return _vm.nastavPoznamkuAndIur(value)
                                        },
                                        select: function(val) {
                                          return _vm.selectVariant(val)
                                        },
                                        openPorovnanieBalikovDialog:
                                          _vm.openPorovnanieBalikovDialog
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "v-expansion-panels",
                  {
                    staticClass: "wizard-expansion-panels",
                    class: { "mt-10px": !_vm.isMobile },
                    attrs: { accordion: "", multiple: "", flat: "" },
                    model: {
                      value: _vm.panel,
                      callback: function($$v) {
                        _vm.panel = $$v
                      },
                      expression: "panel"
                    }
                  },
                  [
                    _c(
                      "v-expansion-panel",
                      { staticClass: "mb-20px" },
                      [
                        _c(
                          "v-expansion-panel-header",
                          { staticClass: "pa-0" },
                          [_vm._v(" Poistenie ")]
                        ),
                        _c(
                          "v-expansion-panel-content",
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": _vm.isMobile } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    !_vm.isMobile
                                      ? _c(
                                          "v-row",
                                          { staticClass: "mt-20px'" },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_kasko,
                                                    expression:
                                                      "poistenie_kasko"
                                                  }
                                                ],
                                                staticClass: "py-0",
                                                attrs: { cols: "3" }
                                              },
                                              [_vm._v(" Havarijné poistenie ")]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_pzp,
                                                    expression: "poistenie_pzp"
                                                  }
                                                ],
                                                staticClass: "py-0",
                                                attrs: { cols: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  " Povinné zmluvné poistenie "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_fs,
                                                    expression: "poistenie_fs"
                                                  }
                                                ],
                                                staticClass: "py-0",
                                                attrs: { cols: "3" }
                                              },
                                              [
                                                _vm._v(
                                                  " Poistenie finančnej straty "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.poistenie_olfs_kasko,
                                                    expression:
                                                      "poistenie_olfs_kasko"
                                                  }
                                                ],
                                                staticClass: "py-0",
                                                attrs: { cols: "3" }
                                              },
                                              [_vm._v(" Operatívny leasing ")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "mb-10px",
                                        class: { "mt-10px": !_vm.isMobile },
                                        attrs: { "no-gutters": _vm.isMobile }
                                      },
                                      [
                                        _vm.isMobile
                                          ? _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_kasko,
                                                    expression:
                                                      "poistenie_kasko"
                                                  }
                                                ],
                                                staticClass: "bold my-4",
                                                attrs: { cols: "12" }
                                              },
                                              [_vm._v(" Havarijné poistenie ")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.poistenie_kasko,
                                                expression: "poistenie_kasko"
                                              }
                                            ],
                                            attrs: { md: "3", sm: "12" }
                                          },
                                          [
                                            _vm.poistenie_kasko
                                              ? _c("poistenie-card", {
                                                  attrs: {
                                                    value: _vm.poistenie_kasko,
                                                    "data-id":
                                                      "liw_filip__wiz_poistenie__cb_poistenie_kasko",
                                                    newId: _vm.pripad.newId,
                                                    cisloPredmetu:
                                                      _vm.predmet
                                                        .cislo_predmetu,
                                                    sumar: 1
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm.isMobile
                                          ? _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_pzp,
                                                    expression: "poistenie_pzp"
                                                  }
                                                ],
                                                staticClass: "bold my-4",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _vm._v(
                                                  " Povinné zmluvné poistenie "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.poistenie_pzp,
                                                expression: "poistenie_pzp"
                                              }
                                            ],
                                            attrs: { md: "3", sm: "12" }
                                          },
                                          [
                                            _vm.poistenie_pzp
                                              ? _c("poistenie-card", {
                                                  attrs: {
                                                    value: _vm.poistenie_pzp,
                                                    "data-id":
                                                      "liw_filip__wiz_poistenie__cb_poistenie_pzp",
                                                    newId: _vm.pripad.newId,
                                                    cisloPredmetu:
                                                      _vm.predmet
                                                        .cislo_predmetu,
                                                    sumar: 1
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm.isMobile
                                          ? _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.poistenie_fs,
                                                    expression: "poistenie_fs"
                                                  }
                                                ],
                                                staticClass: "bold my-4",
                                                attrs: { cols: "12" }
                                              },
                                              [
                                                _vm._v(
                                                  " Poistenie finančnej straty "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.poistenie_fs,
                                                expression: "poistenie_fs"
                                              }
                                            ],
                                            attrs: { md: "3", sm: "12" }
                                          },
                                          [
                                            _vm.poistenie_fs
                                              ? _c("poistenie-card", {
                                                  attrs: {
                                                    value: _vm.poistenie_fs,
                                                    "data-id":
                                                      "liw_filip__wiz_poistenie__cb_poistenie_fs",
                                                    newId: _vm.pripad.newId,
                                                    cisloPredmetu:
                                                      _vm.predmet
                                                        .cislo_predmetu,
                                                    sumar: 1
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm.isMobile
                                          ? _c(
                                              "v-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.poistenie_olfs_kasko,
                                                    expression:
                                                      "poistenie_olfs_kasko"
                                                  }
                                                ],
                                                staticClass: "bold my-4",
                                                attrs: { cols: "12" }
                                              },
                                              [_vm._v(" Operatívny leasing ")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.poistenie_olfs_kasko,
                                                expression:
                                                  "poistenie_olfs_kasko"
                                              }
                                            ],
                                            attrs: { md: "3", sm: "12" }
                                          },
                                          [
                                            _vm.poistenie_olfs_kasko
                                              ? _c("poistenie-card", {
                                                  attrs: {
                                                    value:
                                                      _vm.poistenie_olfs_kasko,
                                                    "data-id":
                                                      "liw_filip__wiz_poistenie__cb_poistenie_olfs",
                                                    newId: _vm.pripad.newId,
                                                    cisloPredmetu:
                                                      _vm.predmet
                                                        .cislo_predmetu,
                                                    sumar: 1,
                                                    isOlfs: ""
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panel",
                      [
                        _c(
                          "v-expansion-panel-header",
                          { staticClass: "pa-0" },
                          [_vm._v(" Informácie o predmete ")]
                        ),
                        _c(
                          "v-expansion-panel-content",
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": _vm.isMobile } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { xs: "12", sm: "12", md: "9" } },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        class: {
                                          "mt-20px": !_vm.isMobile,
                                          "d-flex flex-column mt-4":
                                            _vm.isMobile
                                        },
                                        attrs: { "no-gutters": "" }
                                      },
                                      [
                                        _vm.predmet.je_auto === 1
                                          ? _vm._l(
                                              _vm.infoPredmetHeaders,
                                              function(header) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: header.value,
                                                    class: {
                                                      "pb-2": !_vm.isMobile,
                                                      "pb-3": _vm.isMobile
                                                    },
                                                    attrs: {
                                                      xs: "12",
                                                      sm: "12",
                                                      md: "4"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          "no-gutters": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "f12 gs100"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                header.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    header.value != "dat_reg"
                                                      ? _c(
                                                          "v-row",
                                                          {
                                                            class: {
                                                              bold:
                                                                header.text !=
                                                                "VIN",
                                                              "pb-6":
                                                                _vm.predmet[
                                                                  header.value
                                                                ] == null
                                                            },
                                                            attrs: {
                                                              "no-gutters": ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "f16"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.predmet[
                                                                      header
                                                                        .value
                                                                    ] == null
                                                                      ? ""
                                                                      : header.suffix
                                                                      ? _vm.predmet[
                                                                          header
                                                                            .value
                                                                        ].formatSuffix(
                                                                          header.suffix
                                                                        )
                                                                      : _vm
                                                                          .predmet[
                                                                          header
                                                                            .value
                                                                        ]
                                                                  ) + " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "v-row",
                                                          {
                                                            attrs: {
                                                              "no-gutters": ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "f16 bold"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.predmet
                                                                      .datum_1_reg
                                                                      ? _vm.predmet.datum_1_reg.formatDate()
                                                                      : ""
                                                                  ) + " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : _vm._l(
                                              _vm.infoStrojHeaders,
                                              function(header) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: header.value,
                                                    class: {
                                                      "pb-2": !_vm.isMobile,
                                                      "pb-3": _vm.isMobile
                                                    },
                                                    attrs: {
                                                      xs: "12",
                                                      sm: "12",
                                                      md: "4"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          "no-gutters": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "f12 gs100"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                header.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        class: {
                                                          bold:
                                                            header.text !=
                                                            "VIN",
                                                          "pb-6":
                                                            _vm.predmet[
                                                              header.value
                                                            ] == null
                                                        },
                                                        attrs: {
                                                          "no-gutters": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "f16"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.predmet[
                                                                  header.value
                                                                ] == null
                                                                  ? ""
                                                                  : header.suffix
                                                                  ? _vm.predmet[
                                                                      header
                                                                        .value
                                                                    ].formatSuffix(
                                                                      header.suffix
                                                                    )
                                                                  : _vm.predmet[
                                                                      header
                                                                        .value
                                                                    ]
                                                              ) + " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                        _c(
                                          "v-col",
                                          {
                                            class: { "pb-3": _vm.isMobile },
                                            attrs: {
                                              xs: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                class: {
                                                  "pb-6":
                                                    _vm.predmet
                                                      .obstaravacia_cena == null
                                                },
                                                attrs: { "no-gutters": "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "f12 gs100" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.jeDealer
                                                          ? "Obstarávacia cena"
                                                          : "Kúpna cena"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "bold",
                                                attrs: { "no-gutters": "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "f16" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.predmet
                                                          .obstaravacia_cena
                                                          ? _vm.predmet.obstaravacia_cena.toEurString()
                                                          : ""
                                                      ) + " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            class: { "pb-3": _vm.isMobile },
                                            attrs: {
                                              xs: "12",
                                              sm: "12",
                                              md: "4"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                class: {
                                                  "pb-6":
                                                    _vm.predmet
                                                      .cennikova_cena_s_dph ==
                                                    null
                                                },
                                                attrs: { "no-gutters": "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "f12 gs100" },
                                                  [_vm._v("Cenníková cena")]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "bold",
                                                attrs: { "no-gutters": "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "f16" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.predmet
                                                          .cennikova_cena_s_dph
                                                          ? _vm.predmet.cennikova_cena_s_dph.toEurString()
                                                          : ""
                                                      ) + " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.jeDealer
                      ? _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "pa-0" },
                              [_vm._v(" Poznámka ")]
                            ),
                            _c(
                              "v-expansion-panel-content",
                              {
                                class: {
                                  "pt-5": !_vm.isMobile,
                                  "pt-4": _vm.isMobile
                                }
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    class: {
                                      "d-flex flex-column": _vm.isMobile
                                    },
                                    attrs: { "no-gutters": _vm.isMobile }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { xs: "12", sm: "12", md: "6" }
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "v-col",
                                              [
                                                _c("v-textarea", {
                                                  ref: "textareaPoznamka",
                                                  staticClass:
                                                    "dynamic-input-control",
                                                  attrs: {
                                                    outlined: "",
                                                    rules:
                                                      _vm.poznamkaPredmetu
                                                        .rules,
                                                    dense: "",
                                                    placeholder:
                                                      "Napíšte poznámku",
                                                    counter: "200"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.poznamkaPredmetu
                                                        .message,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.poznamkaPredmetu,
                                                        "message",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "poznamkaPredmetu.message"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              "no-gutters": _vm.isMobile
                                            }
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                class: { "pt-4": _vm.isMobile }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "btn-primary",
                                                    style: _vm.isMobile
                                                      ? { width: "100%" }
                                                      : {},
                                                    attrs: {
                                                      disabled: !_vm.poznamkaPredmetuValid
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.savePoznamkaPredmetu
                                                    }
                                                  },
                                                  [_vm._v(" Uložiť ")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { xs: "12", sm: "12", md: "6" }
                                      },
                                      _vm._l(
                                        _vm.historiaPoznamokPredmetu,
                                        function(historiaPoznamka) {
                                          return _c(
                                            "v-row",
                                            {
                                              key:
                                                historiaPoznamka.value_member,
                                              class: {
                                                "pb-15px": !_vm.isMobile
                                              },
                                              attrs: {
                                                "no-gutters": _vm.isMobile
                                              }
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  class: {
                                                    "pt-4": _vm.isMobile
                                                  }
                                                },
                                                [
                                                  _c("h4", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          historiaPoznamka.modifikoval
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          historiaPoznamka.modifikovane.formatDateTime()
                                                        ) +
                                                        " "
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "white-space":
                                                          "pre-line"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            historiaPoznamka.display_member
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "1000"
          },
          model: {
            value: _vm.poznamka.open,
            callback: function($$v) {
              _vm.$set(_vm.poznamka, "open", $$v)
            },
            expression: "poznamka.open"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Poznámka")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.poznamka.open = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16 white100" },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "white-space": "pre-line",
                        margin: "0px 16px"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.poznamka.text) + " ")]
                  ),
                  _vm.poznamka.text != null && _vm.iur.items.length > 0
                    ? _c("v-divider", { staticStyle: { "margin-top": "16px" } })
                    : _vm._e(),
                  _vm.iur.items.length > 0
                    ? _c("v-data-table", {
                        staticClass: "standard-table",
                        attrs: {
                          headers: _vm.iur.headers,
                          items: _vm.iur.items,
                          "hide-default-footer": "",
                          "disable-pagination": "",
                          "disable-sort": "",
                          dense: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.poznamka.open = false
                        }
                      }
                    },
                    [_vm._v(" Zavrieť ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "500"
          },
          model: {
            value: _vm.podpisovanieDokumentov,
            callback: function($$v) {
              _vm.podpisovanieDokumentov = $$v
            },
            expression: "podpisovanieDokumentov"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Podpisovanie dokumentov")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.podpisovanieDokumentov = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16" },
                [
                  _vm._v(
                    " Zmluvu za spoločnosť " +
                      _vm._s(_vm.currentProfileName) +
                      " bude podpisovať: "
                  ),
                  _c("br"),
                  _c("span", { staticClass: "gs200" }, [
                    _vm._v(
                      " (prosím vyberte prosím zo zoznamu podpisujúcich opravených konať za spoločnosť) "
                    )
                  ]),
                  _c(
                    "v-form",
                    {
                      ref: "podpisovanieForm",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("dynamic-combo", {
                        staticClass: "mr-16px mt-12px",
                        attrs: {
                          rules: [_vm.podpisovanie],
                          label: "Zoznam oprávnených osôb",
                          multiple: "",
                          items: _vm.opravneneOsoby,
                          displayMember: "menoApriezvisko",
                          valueMember: "id_zastupcu",
                          cache: false
                        },
                        model: {
                          value: _vm.osobyNaPodisanie,
                          callback: function($$v) {
                            _vm.osobyNaPodisanie = $$v
                          },
                          expression: "osobyNaPodisanie"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: { click: _vm.podpisatDokumenty }
                    },
                    [_vm._v(" Pokračovať ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "500"
          },
          model: {
            value: _vm.doplnenieIbanDialog,
            callback: function($$v) {
              _vm.doplnenieIbanDialog = $$v
            },
            expression: "doplnenieIbanDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Doplňujúce informácie")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.doplnenieIbanDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "checkIbanForm",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("v-text-field", {
                        staticClass:
                          "dynamic-input-control required mt-20px mr-16px",
                        attrs: {
                          label: "IBAN",
                          rules: [_vm.required],
                          outlined: "",
                          "error-messages": _vm.ibanErrorText,
                          required: ""
                        },
                        on: {
                          focusout: function(v) {
                            return _vm.checkCorrectnessIban(this$1.iban)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.aktualizovatIban($event)
                          }
                        },
                        model: {
                          value: _vm.iban,
                          callback: function($$v) {
                            _vm.iban = $$v
                          },
                          expression: "iban"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: { click: _vm.aktualizovatIban }
                    },
                    [_vm._v(" Pokračovať ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "500"
          },
          model: {
            value: _vm.doplnenieVinDialog,
            callback: function($$v) {
              _vm.doplnenieVinDialog = $$v
            },
            expression: "doplnenieVinDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Doplňujúce informácie")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.doplnenieVinDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16" },
                [
                  _vm._v(
                    " Pre pokračovanie prosím doplňte nasledujúce informácie. "
                  ),
                  _c("br"),
                  _c(
                    "v-form",
                    {
                      ref: "checkVinForm",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("v-text-field", {
                        staticClass:
                          "dynamic-input-control required mt-20px mr-16px",
                        attrs: {
                          label:
                            "Výrobné číslo" + (_vm.jeAutomobil ? " (VIN)" : ""),
                          rules: [_vm.required, _vm.vinRule],
                          outlined: "",
                          "error-messages": _vm.vinErrorText,
                          required: ""
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.aktualizovatVin($event)
                          }
                        },
                        model: {
                          value: _vm.vin,
                          callback: function($$v) {
                            _vm.vin = $$v
                          },
                          expression: "vin"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm.prekalkulovat
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-secondary",
                          on: { click: _vm.prekalkulovatPonuku }
                        },
                        [_vm._v(" Prekalkulovať ponuku ")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: { click: _vm.aktualizovatVin }
                    },
                    [_vm._v(" Pokračovať ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "500"
          },
          model: {
            value: _vm.doplnenieInformaciiDialog,
            callback: function($$v) {
              _vm.doplnenieInformaciiDialog = $$v
            },
            expression: "doplnenieInformaciiDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Doplňujúce informácie")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.doplnenieInformaciiDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16" },
                [
                  _c("v-checkbox", {
                    class: {
                      dynamic_check_box: true
                    },
                    staticStyle: {
                      "white-space": "nowrap",
                      "margin-top": "0px"
                    },
                    attrs: { label: "Som platca DPH ", "hide-details": "" },
                    on: { change: _vm.onChangePlatcaDPH },
                    model: {
                      value: _vm.doplnujuceInformacie.platcaDph,
                      callback: function($$v) {
                        _vm.$set(_vm.doplnujuceInformacie, "platcaDph", $$v)
                      },
                      expression: "doplnujuceInformacie.platcaDph"
                    }
                  }),
                  _c("br"),
                  _c(
                    "v-form",
                    {
                      ref: "doplnujuceInformacieForm",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("v-text-field", {
                        staticClass:
                          "dynamic-input-control required mt-20px mr-16px",
                        attrs: {
                          label: "IČ DPH",
                          rules: _vm.doplnujuceInformacie.platcaDph
                            ? [_vm.required]
                            : [],
                          outlined: "",
                          disabled: !_vm.doplnujuceInformacie.platcaDph,
                          required: ""
                        },
                        on: {
                          input: function(v) {
                            return (_vm.doplnujuceInformacie.dic =
                              !!_vm.doplnujuceInformacie.ic_dph &&
                              _vm.doplnujuceInformacie.ic_dph.includes("SK")
                                ? _vm.doplnujuceInformacie.ic_dph.replace(
                                    "SK",
                                    ""
                                  )
                                : _vm.doplnujuceInformacie.dic)
                          }
                        },
                        model: {
                          value: _vm.doplnujuceInformacie.ic_dph,
                          callback: function($$v) {
                            _vm.$set(_vm.doplnujuceInformacie, "ic_dph", $$v)
                          },
                          expression: "doplnujuceInformacie.ic_dph"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass:
                          "dynamic-input-control required mt-20px mr-16px",
                        attrs: {
                          label: "DIČ",
                          rules: [_vm.required],
                          outlined: "",
                          required: ""
                        },
                        model: {
                          value: _vm.doplnujuceInformacie.dic,
                          callback: function($$v) {
                            _vm.$set(_vm.doplnujuceInformacie, "dic", $$v)
                          },
                          expression: "doplnujuceInformacie.dic"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.setIc()
                        }
                      }
                    },
                    [_vm._v(" Pokračovať ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            eager: "",
            "max-width": "500"
          },
          model: {
            value: _vm.sposobPodpisaniaDialog,
            callback: function($$v) {
              _vm.sposobPodpisaniaDialog = $$v
            },
            expression: "sposobPodpisaniaDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", { staticClass: "gs100 f16" }, [
                    _vm._v("Pripraviť zmluvu")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.sposobPodpisaniaDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "f16 pb-0px" },
                [
                  _c(
                    "v-radio-group",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v("Vyberte si spôsob podpísania zmluvy")
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.sposobPodpisania,
                        callback: function($$v) {
                          _vm.sposobPodpisania = $$v
                        },
                        expression: "sposobPodpisania"
                      }
                    },
                    [
                      _vm._l(_vm.sposobyPodpisania, function(item) {
                        return [
                          item.valueMember < 3 ||
                          (item.valueMember == 3 && _vm.jeDealer)
                            ? _c("v-radio", {
                                key: item.valueMember,
                                attrs: {
                                  label: item.displayMember,
                                  value: item.valueMember
                                }
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  ),
                  _vm.sposobPodpisania == 2
                    ? [
                        _c(
                          "v-form",
                          {
                            ref: "vyberPobocky",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c("dynamic-combo", {
                              staticClass: "mr-16px",
                              attrs: {
                                rules: [_vm.required],
                                label: "Zoznam pobočiek",
                                items: _vm.pobocky,
                                displayMember: "adresa",
                                "return-object": "",
                                cache: false,
                                required: ""
                              },
                              model: {
                                value: _vm.pobocka,
                                callback: function($$v) {
                                  _vm.pobocka = $$v
                                },
                                expression: "pobocka"
                              }
                            }),
                            _c("v-divider", { staticClass: "mb-16px" }),
                            _c("span", [
                              _vm._v(
                                "Pri podpisovaní zmluvy na pobočke si môžete vybrať obchodníka"
                              )
                            ]),
                            _c("dynamic-combo", {
                              staticClass: "mt-16px mr-16px",
                              attrs: {
                                disabled: !_vm.obchodnikEnabled,
                                label: "Zoznam obchodníkov",
                                items: _vm.obchodnici,
                                displayMember: "meno",
                                "return-object": "",
                                cache: false
                              },
                              model: {
                                value: _vm.obchodnik,
                                callback: function($$v) {
                                  _vm.obchodnik = $$v
                                },
                                expression: "obchodnik"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: { click: _vm.setSposobPodpisu }
                    },
                    [_vm._v(" Potvrdiť ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.vins.items.length > 0,
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: "",
            "max-width": "1000"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "dialog-card" },
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("h1", [_vm._v("Vyberte si verziu modelu")]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.vins.items = []
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    staticClass: "standard-table row-pointer",
                    attrs: {
                      headers: _vm.vins.headers,
                      items: _vm.vins.items,
                      "disable-pagination": "",
                      "hide-default-footer": ""
                    },
                    on: { "click:row": _vm.selectVerziaModelu }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "896" },
          model: {
            value: _vm.porovnanieBalikovDialog,
            callback: function($$v) {
              _vm.porovnanieBalikovDialog = $$v
            },
            expression: "porovnanieBalikovDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "dialog-card" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex justify-space-between dialog-title-close"
                },
                [
                  _c("span", [_vm._v(" Porovnanie balíkov ")]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.closePorovnanieBalikov()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "gs100" },
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mx-0" },
                            _vm._l(_vm.porovnanieBalikov, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-col",
                                { key: index, attrs: { cols: "12", md: 4 } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticStyle: { gap: "8px" },
                                      attrs: { "no-gutters": "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "bold",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "f18 white100" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item[0].display_member
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._l(item, function(row, rowIndex) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: rowIndex,
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "btn-help porovnanie-balikov-icon",
                                                attrs: { size: "16px" }
                                              },
                                              [_vm._v(" $check_circle ")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                " " + _vm._s(row.sluzba) + " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("message-box", {
        attrs: {
          "yes-no": _vm.warningDialog.yesNo,
          title: _vm.warningDialog.title,
          text: _vm.warningDialog.text,
          action: _vm.warningDialog.action,
          "hide-cancel": _vm.warningDialog.hideCancel,
          zIndex: _vm.warningDialog.zIndex
        },
        model: {
          value: _vm.warningDialog.open,
          callback: function($$v) {
            _vm.$set(_vm.warningDialog, "open", $$v)
          },
          expression: "warningDialog.open"
        }
      }),
      _c(
        "v-overlay",
        {
          attrs: {
            color: "#000",
            opacity: "0.40",
            value: _vm.loading.open,
            "z-index": _vm.loading.zIndex
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "text-center mt-n100px card",
              attrs: { width: "500" }
            },
            [
              _c("v-progress-circular", {
                staticClass: "mb-20px",
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 25,
                  width: 2
                }
              }),
              _c("text-group", {
                attrs: {
                  invert: "",
                  large: "",
                  utext: _vm.loading.utext,
                  btext: _vm.loading.btext,
                  gap: 20
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }